import { getSession } from "next-auth/react";

import api from "@src/api/index";

declare var window: any;
declare var zE: any;

export const chatLogin = async () => {
  const session = await getSession();

  if (!session) {
    return;
  }

  const {
    user: {
      email: sessionEmail,
      image: { user_id },
    },
  } = session;

  const user = await api.getUserByEmail(sessionEmail);

  const { name, lastname, scndlastname, email } = user;

  const fullName = `${name} ${lastname} ${scndlastname}`;

  console.log("zE: ", zE);

  zE("webWidget", "identify", {
    name: fullName,
    email,
  });

  zE("webWidget", "prefill", {
    name: { value: fullName },
    email: { value: email },
  });

  zE("webWidget", "close");
};

export const toggleChat = async ({ eventStatus }) => {
  const command =
    eventStatus.status === "live" ||
    eventStatus.status === "diploma" ||
    (eventStatus.is_summit && eventStatus.status === "vod")
      ? "hide"
      : "show";

  console.log("command: ", command);

  try {
    zE("webWidget", command);
  } catch (err) {
    console.log("err: ", err);
  }
};
